import { render, staticRenderFns } from "./BrandQueryHistory.vue?vue&type=template&id=d39500b0&scoped=true&"
import script from "./BrandQueryHistory.vue?vue&type=script&lang=ts&"
export * from "./BrandQueryHistory.vue?vue&type=script&lang=ts&"
import style0 from "./BrandQueryHistory.vue?vue&type=style&index=0&id=d39500b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d39500b0",
  null
  
)

export default component.exports